<script setup>
import { ref, watch, onUnmounted } from "vue";

let props = defineProps({
    finishCallback: {
        type: Function,
        default: () => {}
    },
    time: {
        type: Number,
        default: 10
    },
    afterText: {
        type: String,
        default: '后自动保存'
    },
    runing: {
        type: Boolean,
        default: true
    }
});

const startingMinutes = props.time || 10;
let time = startingMinutes * 60; // 转换为秒
let showTime = ref(`${startingMinutes.toString().padStart(2, '0')}:00`);
let countdownInterval = null;

const updateTimer = () => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    showTime.value = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    time--;
    if (time < 0) {
        clearInterval(countdownInterval);
        props.finishCallback();
        time = startingMinutes * 60;
        countdownInterval = setInterval(updateTimer, 1000);
    }
};

watch(() => props.runing, (newVal) => {
    if (newVal) {
        time = startingMinutes * 60;
        countdownInterval = setInterval(updateTimer, 1000);
    } else {
        clearInterval(countdownInterval);
    }
}, {
    immediate: true
});

// 组件销毁时清除定时器
onUnmounted(() => {
    console.log('countDown onUnmounted....')
    if (countdownInterval) {
        console.log('countDown clearInterval....') 
        clearInterval(countdownInterval);
        countdownInterval = null;
    }
});

</script>

<template>
  <div class="countDown-body" v-if="props.runing">
    <p class="countDown-box">
      {{ showTime }}
      <span class="after-text">{{ props.afterText }} </span>
    </p>
  </div>
</template>

<style scoped lang="less">
.countDown-body {
    display: inline-block;
    // background: red;
    font-size: 13px;
    color: #999;
    .countDown-box {
        display: inline-block;
        .after-text {
            font-size: 12px;
            font-weight: 500;
        }
    }
}
</style>
